import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DataContainer from 'Components/UI/DataContainer';
import useCollection from 'Hooks/useCollection';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useUserContext from 'Context/UserContext';
import FinancialWellnessView from './FinancialWellnessView';

const FinancialWellnessContainer = ({
  TitleProps,
}) => {
  const { householdResource } = useSimpleHousehold();
  const { isAgent } = useUserContext();
  const { collection, setCollection } = useCollection();

  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(null);

  async function loadData(hhResource) {
    try {
      const coll = await hhResource.relationship('financialWellness').link('related').get();
      setCollection(coll);
    } catch (err) {
      setLoadingError(err);
    }

    setLoading(false);
  }

  useEffect(() => {
    if (householdResource) {
      loadData(householdResource);
    }
  }, [householdResource]);

  return (
    <DataContainer
      backgroundColor="white"
      loading={loading}
      loadingError={loadingError}
      ErrorListProps={{
        title: 'An error occurred while loading Financial Wellness',
      }}
      component={FinancialWellnessView}
      componentProps={{
        collection,
        readOnly: isAgent,
        TitleProps,
      }}
    />
  );
};

FinancialWellnessContainer.defaultProps = {
  TitleProps: {},
};

FinancialWellnessContainer.propTypes = {
  TitleProps: PropTypes.object,
};

export default FinancialWellnessContainer;
